
import React, { Component } from 'react';
import { Grid, Row, Col, Table, Button } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { DownloadMultipleDocumentsForm } from './DownloadMultipleDocumentsForm';
import { PaginationBuilder } from '../../PaginationBuilder';
import { DownloadLinkHelper } from '../../helpers/DownloadLinkHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { DocumentsCommand } from '../commands/DocumentsCommand';
import { DownloadCommand } from '../../files/commands/DownloadCommand';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { TableButton } from '../../TableButton';
import { SortIndicator } from '../../SortIndicator';
import ColumnResize from "react-table-column-resizer";

export class BusSchedDocuments extends Component {
    static contextTypes = {
        selectedProvider: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50,
                filter: ""
            },
            form: {
                documents: []
            },
            commands: {
                documents: new DocumentsCommand(),
                download: new DownloadCommand()
            },
            actions: {
                isLoading: true,
                isSelectingMultipleDocuments: false,
                isDownloadingMultipleDocuments: false
            },
            render: {
                showDownloadMultipleDocumentsForm: false,
                sort: {
                    property: "generationDate",
                    type: "descending"
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.getDocuments();
    }

    // ---------------------------

    getDocuments() {
        const { selectedProvider } = this.context;
        const { commands, actions } = this.state;
        
        let selectedProviderId = '';
        if (undefined !== selectedProvider) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        actions.isLoading = true;
        commands.documents.listBusScheds(
            selectedProviderId,
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a, "isLoading", true)
        );

        this.setState({
            actions: actions
        });
    }

    // ---------------------------

    successCallback(result) {
        const { table, actions } = this.state;

        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    downloadSuccessCallback(blob, name, action) {
        var FileSaver = require('file-saver');
        FileSaver.saveAs(blob, name);

        if (undefined !== action) {
            const { actions } = this.state;

            actions[action] = false;

            this.setState({
                actions: actions
            });
        }
    }

    errorCallback(message, action, reset = false) {
        const { table, actions } = this.state;

        actions[action] = false;
        if (reset) {
            table.page = 1;
            table.data = [];
        }

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onSelectMultipleDocumentsClick(state) {
        const { actions } = this.state;

        actions.isSelectingMultipleDocuments = state;

        this.setState({
            actions: actions
        });
    }

    onDownloadMultipleDocumentsClick() {
        const { render } = this.state;

        render.showDownloadMultipleDocumentsForm = true;

        this.setState({
            render: render
        });
    }

    onRowClick(data) {
        const { form } = this.state;

        if (form.documents.includes(data.fileName)) {
            form.documents = form.documents.filter(document => document !== data.fileName);
        }
        else {
            form.documents.push(data.fileName);
        }

        this.setState({
            form: form
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ''
            }
        });
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    onCleanDocuments() {
        const { form } = this.state;

        form.documents = [];

        this.setState({
            form: form
        });
    }

    onSelectFilteredDocuments() {
        const { table, form } = this.state;

        form.documents = this.filterData(table)
            .map(data => data.fileName);

        this.setState({
            form: form
        });
    }

    onStartDownload(format, name) {
        const { commands } = this.state;

        commands.download.downloadBusSched(format, '',
            (a) => this.downloadSuccessCallback(a, name),
            (a) => this.errorCallback(a, "isLoading")
        );
    }

    onDownloadMultipleDocuments(downloadSvg = true, downloadPng = true, downloadPdf = true) {
        const { table, form, actions, commands } = this.state;
        const documents = [];

        form.documents.forEach(document => {
            const file = table.data.find(data => data.fileName === document);
            if (undefined === file) {
                return;
            }

            if (downloadSvg && undefined !== file.formatSvg && null !== file.formatSvg && "" !== file.formatSvg) {
                documents.push(file.formatSvg);
            }

            if (downloadPng && undefined !== file.formatPng && null !== file.formatPng && "" !== file.formatPng) {
                documents.push(file.formatPng);
            }

            if (downloadPdf && undefined !== file.formatPdf && null !== file.formatPdf && "" !== file.formatPdf) {
                documents.push(file.formatPdf);
            }
        });

        actions.isDownloadingMultipleDocuments = true;
        this.setState({
            actions: actions
        });

        commands.download.downloadMultipleBusSched(documents, '',
            (a) => this.downloadSuccessCallback(a, "Hor�rios.zip", "isDownloadingMultipleDocuments"),
            (a) => this.errorCallback(a, "isDownloadingMultipleDocuments"))
    }

    onConfirmDownloadMultipleDocuments(data) {
        this.onDownloadMultipleDocuments(data.downloadSvg, data.downloadPng, data.downloadPdf);
        this.onCancelDownloadMultipleDocuments();
    }

    onCancelDownloadMultipleDocuments() {
        const { render } = this.state;

        render.showDownloadMultipleDocumentsForm = false;

        this.setState({
            render: render
        });
    }

    // ---------------------------

    filterData(table) {
        const { filter } = this.props;
        
        return SearchHelper.search({
            filter: filter,
            data: table.data,
            fields: ["type", "code", "name", "orientation", "referenceDate", "generationDate"]
        });
    }

    getTableRowClassName(isSelectingMultipleDocuments, selectedDocuments, data) {
        return isSelectingMultipleDocuments ?
            `busched selectable ${selectedDocuments.includes(data.fileName) ? "checked" : ""}` :
            "";
    }

    // ---------------------------

    sortDocuments(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // ---------------------------

    renderDownloadMultipleDocumentsForm(isToShow) {
        if (!isToShow) {
            return null;
        }

        return (
            <DownloadMultipleDocumentsForm
                title="Tipos de documentos a descarregar"
                onConfirm={(a) => this.onConfirmDownloadMultipleDocuments(a)}
                onCancel={() => this.onCancelDownloadMultipleDocuments()} />
        );
    }

    renderLoading(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if(property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderDownloadLink(format, downloadName, extention) {
        if (undefined === format || null === format || "" === format) {
            return null;
        }

        return (
            <TableButton
                icon="icon-download"
                onClick={() => this.onStartDownload(format, DownloadLinkHelper.getDownloadFileName(format, downloadName, extention))}
                title={`Transferir ${extention.toUpperCase()}`}
            />
        );
    }

    renderReferenceDate(presentReferenceDate, referenceDate) {
        if(!presentReferenceDate) {
            return null;
        }

        const value = undefined === referenceDate || null === referenceDate || "" === referenceDate ?
            "-----" :
            referenceDate;

        return (
            <td>
                {value}
            </td>
        );
    }

    renderTableLine(generatorConfigs, idx, data, isSelectingMultipleDocuments, selectedDocuments, onRowClickCallback) {
        return (
            <tr className={this.getTableRowClassName(isSelectingMultipleDocuments, selectedDocuments, data)} onClick={onRowClickCallback} key={`layout-${idx}`}>
                <td>{data.type}</td>
                <td className="column_resizer_body" />
                <td>{data.code}</td>
                <td className="column_resizer_body" />
                <td>{data.name}</td>
                <td className="column_resizer_body" />
                <td>{data.orientation}</td>
                <td className="column_resizer_body" />
                {this.renderReferenceDate(generatorConfigs.presentReferenceDate, data.referenceDate)}
                <td className="column_resizer_body" />
                <td>{data.generationDate}</td>
                <td className="column_resizer_body" />
                <td>{this.renderDownloadLink(data.formatSvg, data.downloadName, "svg")}</td>
                <td className="column_resizer_body" />
                <td>{this.renderDownloadLink(data.formatPng, data.downloadName, "png")}</td>
                <td className="column_resizer_body" />
                <td>{this.renderDownloadLink(data.formatPdf, data.downloadName, "pdf")}</td>
                <td className="column_resizer_body" />
            </tr>
        );
    }

    renderTable(isWaiting, isSelectingMultipleDocuments) {
        const { generatorConfigs } = this.props;
        const { table, form, render } = this.state;

        const dataFiltered = this.filterData(table);
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered
            .sort((a, b) => this.sortDocuments(render.sort, a, b))
            .slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid className="margin-top-15" fluid>
                <Row>
                    <Col sm={12}>
                        <div className="table-loading">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th className="sortable" onClick={() => this.onChangeSort("type")}>Tipo {this.renderSortIndicator("type", render.sort)}</th>
                                        <ColumnResize className="columnResizer" />
                                        <th className="sortable" onClick={() => this.onChangeSort("code")}>Código {this.renderSortIndicator("code", render.sort)}</th>
                                        <ColumnResize className="columnResizer" />
                                        <th className="sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                        <ColumnResize className="columnResizer" />
                                        <th className="sortable" onClick={() => this.onChangeSort("orientation")}>Orientação {this.renderSortIndicator("orientation", render.sort)}</th>
                                        <ColumnResize className="columnResizer" />
                                        {generatorConfigs.presentReferenceDate ? <th className="sortable" onClick={() => this.onChangeSort("referenceDate")}>Data Referência {this.renderSortIndicator("referenceDate", render.sort)}</th> : null}
                                        <ColumnResize className="columnResizer" />
                                        <th className="sortable" onClick={() => this.onChangeSort("generationDate")}>Data Geração {this.renderSortIndicator("generationDate", render.sort)}</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>SVG</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>PNG</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>PDF</th>
                                        <ColumnResize className="columnResizer" />
                                    </tr>
                                </thead>
                                <tbody className={isWaiting ? "overlay" : ""}>
                                    {
                                        partialData.map((data, idx) =>
                                            this.renderTableLine(generatorConfigs, idx, data, isSelectingMultipleDocuments, form.documents, isSelectingMultipleDocuments ? () => this.onRowClick(data) : null)
                                        )
                                    }
                                </tbody>
                            </Table>

                            <PaginationBuilder
                                currentPage={table.page}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={dataFiltered.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                            {this.renderLoading(isWaiting)}
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderDownloadMultipleDocumentsButton(hasAnyDocumentSelected) {
        const { actions } = this.state;

        if (actions.isDownloadingMultipleDocuments) {
            return (
                <Button disabled={true}>A DESCARREGAR...</Button>
            );
        }

        return (
            <Button onClick={() => this.onDownloadMultipleDocumentsClick()} disabled={!hasAnyDocumentSelected}>DESCARREGAR</Button>
        );
    }

    render() {
        const { actions, render, message } = this.state;

        return (
            <div>
                {this.renderTable(actions.isLoading, actions.isSelectingMultipleDocuments)}
                {this.renderDownloadMultipleDocumentsForm(render.showDownloadMultipleDocumentsForm)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}
